<template>
  <div>
    <div>
      <a-input-number
        :min="0"
        :step="1"
        auto-focus
        v-model="inputVal"
        v-show="edit"
        @change="valueChange"
        @blur="valueBlur"/>
    </div>
    <div v-if="!edit" @click="divOnclick" class="text-right" style="height: 32px;line-height: 32px;">{{inputVal}}</div>
  </div>
</template>

<script>
export default {
  name: 'PdText',
  components: {
  },
  props: {
    value: [String, Number],
    rowindex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      edit: false,
      inputVal: 0
    }
  },
  methods: {
    valueChange (value) {
      this.inputVal = value
      this.$emit('inputChange', { rowindex: this.rowindex, value: this.inputVal })
    },
    divOnclick () {
      this.edit = true
    },
    valueBlur () {
      this.edit = false
    }
  },
  created () {
    this.inputVal = this.value
  },
  watch: {
    'value' (val) {
      this.inputVal = val
    }
  }
}
</script>
<style>
  .ant-input-number {
    /*width: auto;*/
  }
  .text-right {
    text-align: right;
  }
</style>
